<template>
  <div class="row justify-between no-wrap">
    <q-chip
      v-if="$_.isObject(props.value)"
      :icon="props.value.icon"
      :label="props.value.label || props.value.value"
      :title="!props.value.tooltip && (props.value.label || props.value.value)"
      :color="props.value.color"
      :dense="props.value.dense || false"
      :square="props.value.square || false"
      :text-color="props.value.textColor"
      :size="props.value.size || 'md'"
    >
      <q-tooltip v-if="props.value.tooltip">
        <template v-if="$_.isArray(props.value.tooltip)">
          <div
            v-for="(value, index) in props.value.tooltip"
            :key="value + ':' + index"
            class="col-auto"
          >
            {{ value }}
          </div>
        </template>
        <template v-else>
          {{ props.value.tooltip }}
        </template>
      </q-tooltip>
    </q-chip>
    <q-chip
      v-else-if="props.value"
      :label="props.value"
    />
    <template v-if="showFilter">
      <q-btn
        v-if="appliedFilter"
        class="col-auto text-grey-9"
        icon="close"
        size="sm"
        @click.stop="clearFilter"
      />
      <q-btn
        v-else
        class="col-auto text-grey-9"
        icon="filter_alt"
        size="sm"
        @click.stop="applyFilter"
      />
    </template>
  </div>
</template>

<script>
import TableCellMixin from 'src/modules/admin/components/model-table/components/TableCellMixin'

export default {
  name: 'ChipCell',
  mixins: [TableCellMixin]
}
</script>
